import { useState, useEffect } from "react";
import Login from "./Login";
import Signup from "./Signup";

function AuthContainer({ isOpen, onClose, initialMode = "login" }) {
  const [mode, setMode] = useState(initialMode);

  useEffect(() => {
    if (isOpen) setMode(initialMode);
  }, [isOpen, initialMode]);

  if (!isOpen) return null;

  return (
    <>
      {mode === "login" && (
        <Login
          onClose={onClose}
          onShowSignup={() => setMode("signup")}
        />
      )}

      {mode === "signup" && (
        <Signup
          onClose={onClose}
          onBackToLogin={() => setMode("login")}
        />
      )}
    </>
  );
}

export default AuthContainer;
